import React from 'react';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import {Button, Typography} from '@mui/material';
import {useLikeStatus} from '../../components/actuality/hooks/useLike';
import {useLikeCount} from '../../components/actuality/hooks/useLike';
import {useDarkMode} from '../darkMode/hook/useDarkMode';

const LikeButton = ({type, contentId}) => {
  const {isLiked, like, dislike} = useLikeStatus(type, contentId);
  const {increase, decrease, likeCount} = useLikeCount(type, contentId);
  const {mode} = useDarkMode();
  const handleClick = () => {
    if (isLiked) {
      dislike();
      decrease();
    } else {
      like();
      increase();
    }
  };

  return (
    <Button
      className="liked"
      disabled={false}
      onClick={handleClick}
      sx={{
        backgroundColor: mode.settings.card3BackgroundColor,
        width: {xs: '280px', md: '280px', lg: 'auto'},
        position: 'relative',
      }}>
      {isLiked ? (
        <FavoriteIcon
          id="favoriteIcon"
          role={'img'}
          aria-label="Vous avez aimé l'actualité"
          style={{color: mode.settings.textColor}}
        />
      ) : (
        <FavoriteBorderIcon
          id="favoriteIcon"
          role={'img'}
          aria-label="Vous n'avez pas encore aimé l'actualité"
          style={{color: mode.settings.textColor}}
        />
      )}

      <Typography
        variant={'subtitle3'}
        sx={{fontWeight: 600, color: mode.settings.textColor}}>
          {likeCount} J'aime{likeCount > 1 ? 's' : ''}
      </Typography>
    </Button>
  );
};

export default LikeButton;
